import React, {Component} from 'react';
import {Row, Col, Radio, Select, List, DatePicker, Spin, Modal, Table} from 'antd';
import _ from 'underscore';
import moment from 'moment';
import {api, app} from "../../app";
import BigDataFilter from '../../components/BigDataFilter';
import locale from 'antd/lib/date-picker/locale/zh_CN';
import utils from "../../utils";

const Option = Select.Option;
const MonthPicker = DatePicker.MonthPicker;

class SignTeam extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date_type: '1',
            time: '',
            teamname: '',
            teamposition: '0',
            years: [],
            signList: [],
            posiList: [],
            dateValue: moment(),
            loading: true,
            rights: app.getData('rights'),
            total: 0,
            page: 1,
        };
    }

    setData = async (data) => {
        await app.setStateSync(this, data);
    }

    async componentDidMount() {
        this._isMounted = true;
        let now_year = new Date().getFullYear(),
            years = _.range(2018, now_year + 1);
        await this.setData({years, time: years[1]});
        await this.handlePosiData();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    /**
     * 职位数据
     * @returns {Promise<void>}
     */
    handlePosiData = async () => {
        await this.setData({po_loading: true});
        let {flag, data, msg} = await app.post(api.PosttionList);
        let state = {po_loading: false};
        if (flag === 1) {
            state.posiList = data;
        } else {
            app.alert(msg, 'warn');
        }
        await this.setData(state);
    }

    /**
     * 数据
     * @returns {Promise<void>}
     */
    dataSource = async () => {
        await this.setData({loading: true});
        let {date_type, time, filter, teamposition} = this.state;
        let params = {
            date_type,
            teamposition,
            time,
            mark: filter.mark,
            type: filter.type,
            indexno: app.getData("indexno"),
            account: app.getData("account"),
        };
        let {flag, data, msg} = await app.post(api.SiginRate, params);
        if (flag === 1) {
            await this.setData({
                signList: utils.addArrayKey(data),
                loading: false
            });
        } else {
            app.alert(msg, "error");
        }
    }

    /**
     * 筛选变更
     * @param res
     */
    handleFilterChange = async (filter) => {
        let teamname = filter.teamname;
        delete filter.teamname;
        await this.setData({filter, teamname});
        await this.dataSource();
    }

    /**
     * 签到率筛选变更
     * @param res
     */
    handleDateChange = async (e) => {
        let {value} = e.target;
        let {time, years, dateValue} = this.state;
        if (value === '1') {
            time = years[0];
        } else {
            dateValue = moment();
            time = dateValue.format("YYYY-MM");
        }
        await this.setData({time, dateValue, date_type: value});
        await this.dataSource();
    }

    /**
     * 职位筛选变更
     * @param teamposition
     */
    handlePositionChange = async (value) => {
        let teamposition = value.join(',') || '0';
        await this.setData({teamposition});
        await this.dataSource();
    }

    /**
     * 签到年月变更
     * @param res
     */
    handleTimeChange = async (time) => {
        await this.setData({time});
        await this.dataSource();
    }

    /**
     * 数据
     * @returns {Promise<void>}
     */
    detailDataSource = async (page) => {
        await this.setData({page, pSignList: [], d_loading: true});
        let {filter, date_type, teamposition, detailInfo} = this.state, params = Object.assign(filter, {
            page,
            date_type,
            teamposition,
            start_time: detailInfo.start_time,
            end_time: detailInfo.end_time,
            indexno: app.getData("indexno"),
            account: app.getData("account"),
        });
        let {flag, data, msg, total} = await app.post(api.SiginPersonalRate, params);
        let state = {d_loading: false};
        if (flag === 1) {
            state.pSignList = utils.addArrayKey(data);
            state.total = parseInt(total || 0);
            state.d_loading = page !== this.state.page;
        } else {
            app.alert(msg, "error");
        }
        await this.setData(state);
    }

    /**
     * 打开弹框
     * @param mark
     * @returns {Promise<void>}
     */
    handleOpenModal = async (item) => {
        await this.setData({d_visible: true, detailInfo: item});
        await this.detailDataSource(1);
    }

    /**
     * 关闭弹框
     * @returns {Promise<void>}
     */
    handleCloseModal = async () => {
        await this.setData({d_visible: false, detailInfo: {}, total: 0});
    }

    render() {
        let {loading, po_loading, signList, date_type, time, years, dateValue, teamname, page, total, rights, posiList, d_visible, d_loading, pSignList} = this.state,
            sign_rights = app.getData('sign_rights'),
            columns = [
                {
                    title: '姓名',
                    dataIndex: 'vname',
                    key: 'vname',
                    width: '30%'
                },
                {
                    title: '职位',
                    dataIndex: 'teampositionname',
                    key: 'teampositionname',
                    width: '40%'
                },
                {
                    title: '个人签到率',
                    dataIndex: 'rate',
                    key: 'rate',
                    width: '30%'
                },
            ];
        return (
            <div className="sign-team page">
                <div className="page-title">队伍签到时间率</div>
                <div className="page-content">
                    <BigDataFilter change={this.handleFilterChange}/>
                    <div className="posi-filter">
                        <span>队内职务：</span>
                        <Select style={{marginLeft: 10, minWidth: 200, maxWidth: 'calc(100% - 80px)'}} mode="multiple"
                                onChange={this.handlePositionChange}
                                notFoundContent={po_loading ? <Spin size="small"/> : '暂无记录'}
                                disabled={rights !== 1 && sign_rights != 1} placeholder="默认全部职务" allowClear>
                            {
                                posiList.map((posi, i) => {
                                    return (
                                        <Option key={i} value={posi.position_id}>{posi.position_name}</Option>
                                    );
                                })
                            }
                        </Select>
                    </div>
                    <div className="date-filter">
                        <Radio.Group value={date_type} buttonStyle="solid" onChange={this.handleDateChange}>
                            <Radio.Button value="1">月签到率</Radio.Button>
                            <Radio.Button value="2">周签到率</Radio.Button>
                            <Radio.Button value="3">日签到率</Radio.Button>
                        </Radio.Group>
                    </div>

                    <div className="list-body">
                        <List
                            size="small"
                            loading={loading}
                            locale={app.tbLocale(loading)}
                            header={
                                <Row className="list-head" gutter={20}>
                                    <Col span={10}>{teamname}</Col>
                                    <Col span={14} style={{textAlign: 'right'}}>
                                        <span>{date_type === '1' ? '年份' : '月份'}</span>
                                        {date_type === '1' ?
                                            (
                                                <Select style={{width: 100, marginLeft: 10}} value={time}
                                                        onChange={this.handleTimeChange}
                                                        size="small">
                                                    {
                                                        years.map((year, i) => {
                                                            return (
                                                                <Option key={i} value={year}>{year}</Option>
                                                            );
                                                        })
                                                    }
                                                </Select>
                                            ) : (
                                                <MonthPicker style={{width: 120, marginLeft: 10}}
                                                             value={dateValue}
                                                             size="small"
                                                             locale={locale} format="YYYY-MM"
                                                             onChange={async (date) => {
                                                                 await this.handleTimeChange(date.format("YYYY-MM"));
                                                                 await this.setData({dateValue: date});
                                                             }}
                                                             disabledDate={(current) => {
                                                                 return current && (current > moment().endOf('day') || current < moment("2018-07-31").endOf('day'));
                                                             }}/>
                                            )
                                        }
                                    </Col>
                                </Row>
                            }
                            dataSource={signList}
                            renderItem={item => (
                                <List.Item>
                                    <List.Item.Meta
                                        title={item.time}
                                    />
                                    <div>
                                        <span className="see-link"
                                              onClick={() => this.handleOpenModal(item)}>查看签到详情</span>
                                        <span>{"签到率：" + item.rate}</span>
                                    </div>
                                </List.Item>
                            )}
                        />
                    </div>
                    <Modal visible={d_visible}
                           width={600}
                           title={<div style={{textAlign: 'center', fontWeight: 'bold'}}>查看详情</div>}
                           footer={null}
                           className="sign-team-detail-modal"
                           onCancel={this.handleCloseModal}>
                        <div style={{marginBottom: 10}}>共{total}人</div>
                        <Table columns={columns}
                               loading={d_loading}
                               locale={app.tbLocale(d_loading)}
                               dataSource={pSignList}
                               scroll={{y: 400}}
                               size="small"
                               pagination={{
                                   total,
                                   current: page,
                                   pageSize: 20,
                                   onChange: async (current) => {
                                       await this.detailDataSource(current);
                                   }
                               }}
                               footer={null}/>
                    </Modal>
                </div>
            </div>
        );
    }
}

export default SignTeam;



// WEBPACK FOOTER //
// ./src/routes/bigData/SignTeam.jsx